module.exports = __webpack_public_path__ + "static/media/login-guest-button.0221e08e.png";